module.exports = {
    videoPageSettings: {

        beweglichkeit_pro_balance_videos: {
            backDestinationName: 'productpage',
            backDestinationParam: 'beweglichkeit_pro_balance',
            videos: [
                {
                    path: 'data/videos/ProBalance_Gleichgewicht.mp4',
                    description: 'Pro Balance – Das perfekte Gleichgewicht',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/ProBalance_Gleichgewicht.jpg")})`
                    }
                }
            ]
        },

        erschoepfung_pro_balance_videos: {
            backDestinationName: 'productpage',
            backDestinationParam: 'erschoepfung_pro_balance',
            videos: [
                {
                    path: 'data/videos/ProBalance_Gleichgewicht.mp4',
                    description: 'Pro Balance – Das perfekte Gleichgewicht',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/ProBalance_Gleichgewicht.jpg")})`
                    }
                }
            ]
        },

        kreislauf_pro_balance_videos: {
            backDestinationName: 'productpage',
            backDestinationParam: 'kreislauf_pro_balance',
            videos: [
                {
                    path: 'data/videos/ProBalance_Gleichgewicht.mp4',
                    description: 'Pro Balance – Das perfekte Gleichgewicht',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/ProBalance_Gleichgewicht.jpg")})`
                    }
                }
            ]
        },

        immunsystem_aloevera_trinkgel_honey: {
            backDestinationName: 'productpage',
            backDestinationParam: 'immunsystem_aloevera_trinkgel_honey',
            videos: [
                {
                    path: 'data/videos/lifetakt_basisprodukte.mp4',
                    description: 'Tägliche Basisprodukte für ein starkes Immunsystem',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/lifetakt_basisprodukte.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_body_mission_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_body_mission',
            videos: [
                {
                    path: 'data/videos/lifetakt_bodymission.mp4',
                    description: 'Die ausgewogene Ernährungspalette für ein „gesundes und nachhaltiges Abnehmen“',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/lifetakt_bodymission.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_daily_essentials_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_daily_essentials',
            videos: [
                {
                    path: 'data/videos/lifetakt_basisprodukte.mp4',
                    description: 'Gesunde Nährstoffversorgung für jeden Tag',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/lifetakt_basisprodukte.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_5in1_mensshot_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_5in1_mensshot',
            videos: [
                {
                    path: 'data/videos/Film_5in1_Mens_Shot.mp4',
                    description: '5in1 Men´s Shot -  Alles was Mann braucht',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/Film_5in1_Mens_Shot.jpg")})`
                    }
                },
                {
                    path: 'data/videos/Expertenvideo_1.mp4',
                    description: 'Warum gibt es das 5-in-1 jetzt für Männer ?',
                    style: {
                        left: "26%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/Expertenvideo-1.jpg")})`
                    }
                },
                {
                    path: 'data/videos/Expertenvideo_2.mp4',
                    description: 'Men´s Shot in seine tägliche Routine integrieren',
                    style: {
                        left: "46%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/Expertenvideo-2.jpg")})`
                    }
                }
                ,
                {
                    path: 'data/videos/Expertenvideo_3.mp4',
                    description: 'Was macht 5-in-1 Men´s Shot so besonders ?',
                    style: {
                        left: "6%",
                        top: "65%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/Expertenvideo-3.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_cell_essence_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_cell_essence',
            videos: [
                {
                    path: 'data/videos/Cell-Essence_Launchfilm_lang.mp4',
                    description: 'Cell Essence Launchfilm',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/Cell-Essence_Launchfilm_lang.jpg")})`
                    }
                },
                {
                    path: 'data/videos/Cell-Essence_Film1.mp4',
                    description: 'CELL Gesundheit 1',
                    style: {
                        left: "26%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/Cell-Essence_Film1.jpg")})`
                    }
                },
                {
                    path: 'data/videos/Cell-Essence_Film2.mp4',
                    description: 'CELL Gesundheit 2',
                    style: {
                        left: "46%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/Cell-Essence_Film2.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_cannaloe_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_cannaloe',
            videos: [
                {
                    path: 'data/videos/cannaloe.mp4',
                    description: 'Cannaloe - Entdecke die Power',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/cannaloe.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_lr_lifetakt_konzept_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_lr_lifetakt_konzept',
            videos: [
                {
                    path: 'data/videos/lifetakt_markenfilm.mp4',
                    description: 'LIFETAKT Markenfilm',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/lifetakt_markenfilm.jpg")})`
                    }
                },
                {
                    path: 'data/videos/aloevera_heilkraft.mp4',
                    description: 'Die Heilkraft der Aloe Vera',
                    style: {
                        left: "26%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/aloevera_heilkraft.jpg")})`
                    }
                },
                {
                    path: 'data/videos/aloevera_produktion.mp4',
                    description: 'Aloe Vera Produktion, Verarbeitung, Zertifizierung',
                    style: {
                        left: "46%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/aloevera_produktion.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_mental_power_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_mental_power',
            videos: [
                {
                    path: 'data/videos/stressfreie_radikale.mp4',
                    description: 'Stress Freie Radikale',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/stressfreie_radikale.jpg")})`
                    }
                },
                {
                    path: 'data/videos/lifetakt_mentalpower.mp4',
                    description: 'Tägliche Nährstoffversorgung für ein belastbares Nervensystem und Konzentration',
                    style: {
                        left: "26%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/lifetakt_mentalpower.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_night_essentials_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_night_essentials',
            videos: [
                {
                    path: 'data/videos/nightmaster.mp4',
                    description: 'Gesund einschlafen und erholt aufwachen',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/nightmaster.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_pro_activity_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_pro_activity',
            videos: [
                {
                    path: 'data/videos/lifetakt_proactivity.mp4',
                    description: 'Tägliche Nährstoffversorgung für einen gesunden und schmerzfreien Bewegungsapparat',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/lifetakt_proactivity.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_seasonal_support_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_seasonal_support',
            videos: [
                {
                    path: 'data/videos/lifetakt_seasonal.mp4',
                    description: 'Tägliche Nährstoffversorgung für ein starkes Immunsystem',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/lifetakt_seasonal.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_true_beauty_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_true_beauty',
            videos: [
                {
                    path: 'data/videos/5in1.mp4',
                    description: 'Effektive Basisversorgung für die Schönheit von innen',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/5in1.jpg")})`
                    }
                }
            ]
        },

        fuerjedelebenslage_vital_care_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'fuerjedelebenslage_vital_care',
            videos: [
                {
                    path: 'data/videos/lifetakt_vitalcare.mp4',
                    description: 'Tägliche Nährstoffversorgung für ein gesundes Herz-Kreislaufsystem',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/lifetakt_vitalcare.jpg")})`
                    }
                }
            ]
        },

        einzelneprodukte_pro12_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_pro12',
            videos: [
                {
                    path: 'data/videos/probiotika.mp4',
                    description: 'Probiotika Erklärung',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/probiotika.jpg")})`
                    }
                }
            ]
        },

        einzelneprodukte_mind_master_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_mind_master',
            videos: [
                {
                    path: 'data/videos/mindmaster_erfahrungsbericht.mp4',
                    description: 'Mindmaster Erfahrungsbericht',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/mindmaster_erfahrungsbericht.jpg")})`
                    },
                },
                {
                    path: 'data/videos/stressfreie_radikale.mp4',
                    description: 'Stress Freie Radikale',
                    style: {
                        left: "26%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/stressfreie_radikale.jpg")})`
                    },
                },
                {
                    path: 'data/videos/mindmaster_freieradikale.mp4',
                    description: 'Freie Radikale kurz erklärt',
                    style: {
                        left: "46%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/mindmaster_freieradikale.jpg")})`
                    },
                }
            ]
        },

        einzelneprodukte_aloe_vera_drinking_gel_1_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_aloe_vera_drinking_gel',
            videos: [
                {
                    path: 'data/videos/aloevera_wirkung.mp4',
                    description: 'AloeVera Wirkung auf Gefässe und Organismus',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/aloevera_wirkung.jpg")})`
                    }
                }
            ]
        },

        einzelneprodukte_die_aloe_vera_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_die_aloe_vera',
            videos: [
                {
                    path: 'data/videos/aloevera_wirkung.mp4',
                    description: 'Die Heilkraft der Aloe Vera',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/aloevera_wirkung.jpg")})`
                    }
                }
            ]
        },

        einzelneprodukte_cistus_incanus_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_cistus_incanus',
            videos: [
                {
                    path: 'data/videos/cistus_incanus.mp4',
                    description: 'Cistus Incanus antiviral und antibakteriell',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/cistus_incanus.jpg")})`
                    }
                }
            ]
        },

        einzelneprodukte_pro_balance_1_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'einzelneprodukte_pro_balance',
            videos: [
                {
                    path: 'data/videos/ProBalance_Gleichgewicht.mp4',
                    description: 'Pro Balance – Das perfekte Gleichgewicht',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/ProBalance_Gleichgewicht.jpg")})`
                    }
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_hair_care_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_hair_care',
            videos: [
                {
                    path: 'data/videos/aloevera_haarpflege.mp4',
                    description: 'Hochwertige Haarpflege',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/aloevera_haarpflege.jpg")})`
                    }
                }
            ]
        },

        kopfbisfuss_lr_aloe_via_die_aloe_vera_video: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_aloe_via_die_aloe_vera',
            videos: [
                {
                    path: 'data/videos/aloevera_pflegeprodukte.mp4',
                    description: 'AloeVia Pflegeprodukte Premiumqualität',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/aloevera_pflegeprodukte.jpg")})`
                    }
                }
            ]
        },

        kopfbisfuss_lr_microsilver_plus_3_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_microsilver_plus',
            videos: [
                {
                    path: 'data/videos/microsilver_microbiome.mp4',
                    description: 'Microbiome Expertenvideo',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/microsilver_microbiome.jpg")})`
                    }
                },
                {
                    path: 'data/videos/microsilver_mouthSpray.mp4',
                    description: 'Mundspray Microsilver Expertenvideo',
                    style: {
                        left: "26%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/microsilver_mouthSpray.jpg")})`
                    }
                },
                {
                    path: 'data/videos/microsilver_mouthwash.mp4',
                    description: 'Mundspülung Microsilver Expertenvideo',
                    style: {
                        left: "46%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/microsilver_mouthwash.jpg")})`
                    }
                }
            ]
        },

        kopfbisfuss_lr_microsilver_plus_6_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_microsilver_plus',
            videos: [
                {
                    path: 'data/videos/microsilver_handcreme.mp4',
                    description: 'Handcreme Microsilver Expertenvideo',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/microsilver_handcreme.jpg")})`
                    }
                }
            ]
        },

        kopfbisfuss_lr_zeitgard_cleansing_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_cleansing',
            videos: [
                {
                    path: 'data/videos/zeitgard_erklaerung.mp4',
                    description: 'Dr. Voss Zeitgard 1 - Cleaningsystem',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/zeitgard_erklaerung.jpg")})`
                    }
                },
                {
                    path: 'data/videos/zeitgard_hautreinigung.mp4',
                    description: 'Zeitgard 1 - Anschauung Hautreinigung',
                    style: {
                        left: "26%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/zeitgard_hautreinigung.jpg")})`
                    }
                }
            ]
        },

        kopfbisfuss_lr_zeitgard_anti_age_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_anti_age',
            videos: [
                {
                    path: 'data/videos/zeitgard_glaetten.mp4',
                    description: 'Dr. Voss Zeitgard 2 – Anti Age System',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/zeitgard_glaetten.jpg")})`
                    }
                }
            ]
        },

        kopfbisfuss_lr_zeitgard_care_11_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'kopfbisfuss_lr_zeitgard_care',
            videos: [
                {
                    path: 'data/videos/bluelight_defender.mp4',
                    description: 'Blue Light Defender - Gegen Digital Aging',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/bluelight_defender.jpg")})`
                    }
                }
            ]
        },

        duefte_herren_stars_1_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_herren_stars',
            videos: [
                {
                    path: 'data/videos/pure_kretschmer.mp4',
                    description: 'PURE by guido maria kretschmer',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/pure_kretschmer.jpg")})`
                    }
                }
            ]
        },

        duefte_damen_stars_1_videos: {
            backDestinationName: 'slidepage',
            backDestinationParam: 'duefte_damen_stars',
            videos: [
                {
                    path: 'data/videos/pure_kretschmer.mp4',
                    description: 'PURE by guido maria kretschmer',
                    style: {
                        left: "6%",
                        top: "25%",
                        backgroundImage: `url(${require("@/assets/video_kacheln/pure_kretschmer.jpg")})`
                    }
                }
            ]
        },

    }
}